export const toNumber = (number?: unknown) => {
  if (typeof number === 'number' && !isNaN(number)) return number;
  const num = Number(number);
  return isNaN(num) ? 0 : num;
};

export const getPercent = (value: number, total: number) => toNumber(((value / total) * 100).toFixed(2));

export const getPercentDifference = (value: number, total: number) => {
  return 100 - getPercent(value, total);
};

export const toFixedDecimal = (value: number, fixed?: number) => {
  return value.toFixed(fixed ?? 2);
};

export const calcPercent = (value: number, percent: number) => {
  const res = Number((value * percent) / 100);
  return Number.isNaN(res) ? 0 : res;
};

export const getSocialNetworkId = (path: string): string => {
  const segments = path.split('/');
  return segments[segments.length - 1] || '';
};

export const getFormattedNumber = (value: number): string => {
  return new Intl.NumberFormat('fr-FR').format(value);
};

export const formatMoney = (value: number | string | null | undefined): string => {
  if (value === null || value === undefined || value === '') {
    return '—';
  }

  const num = Number(value);

  if (Number.isNaN(num)) {
    return '—';
  }

  return num.toFixed(2);
};

// Money formatted with space thousand separators and a comma decimal (e.g. "444 444,00"),
// matching the Orders summary style.
export const formatMoneyWithSeparators = (value: number | string | null | undefined): string => {
  if (value === null || value === undefined || value === '') {
    return '—';
  }

  const num = Number(value);

  if (Number.isNaN(num)) {
    return '—';
  }

  return new Intl.NumberFormat('fr-FR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(num);
};

export const resolveNumberLocale = (lang?: string): string => {
  if (!lang) return 'uk-UA';
  if (lang.startsWith('en')) return 'en-US';
  if (lang.startsWith('ru')) return 'ru-RU';
  return 'uk-UA';
};

export const formatLocaleNumber = (value: number, decimals = 1, lang?: string): string =>
  new Intl.NumberFormat(resolveNumberLocale(lang), {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(value);

export const formatPercentValue = (value: number, decimals = 1, lang?: string): string =>
  `${formatLocaleNumber(value, decimals, lang)}%`;

/** Compact UAH for donut centers, e.g. "2,76 млн" / "18,64 млн". */
export const formatMoneyCompact = (value: number, lang?: string): string => {
  const abs = Math.abs(value);
  if (abs >= 1_000_000) {
    return `${formatLocaleNumber(value / 1_000_000, 2, lang)} млн`;
  }
  if (abs >= 1_000) {
    return `${formatLocaleNumber(value / 1_000, 1, lang)} тис.`;
  }
  return formatMoneyWithSeparators(value);
};
